module.exports = __webpack_public_path__ + "8a5764ea70cc7ccbc0ae9913d41c68b9.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/left_hand/credit-card.png
// module id = 2379
// module chunks = 0